module.exports = __webpack_public_path__ + "assets/img/março-on-fire-restaurantes-story.e897b155.png";